import { z } from 'zod';
export type SiteDomainIntent =
  | { action: 'connect'; hostname: string }
  | { action: 'check' | 'disconnect' };
const connectBody = z
  .object({ hostname: z.string().trim().min(4).max(253) })
  .strict();
export function buildSiteDomainPayload(intent: SiteDomainIntent) {
  return intent.action === 'connect'
    ? connectBody.parse({ hostname: intent.hostname })
    : {};
}
